<template>
  <div class="schoolinfo">
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="tab">
      <el-tab-pane label="学校信息" name="first">
        <schoolinfoEdit />
      </el-tab-pane>
      <el-tab-pane label="移动端首页展示图片" name="second">
        <schoolinfoBanner />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import schoolinfoEdit from "./components/schoolinfo-edit/schoolinfo-edit.vue";
import schoolinfoBanner from "./components/schoolinfo-banner/schoolinfo-banner.vue";

export default {
  name: "",
  data() {
    return {
      activeName: "first",
    };
  },
  components: {
    schoolinfoEdit,
    schoolinfoBanner,
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
  },
};
</script>

<style lang="scss" scoped >
@import "./schoolinfo.scss";
</style>